import React, { Component } from "react";
import { Api } from "../../app-controller";

class InfoForm extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset>
            <legend>DATOS GENERALES</legend>

            <div className="row">
              <div className="col-lg-4">
                <div className="form-group">
                  <label>Folio regente:</label>
                  <div className="form-control">
                    {this.props.regente.folio_regente}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label>Número de identificación:</label>
                  <div className="form-control">
                    {this.props.regente.numero_identificacion}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label>Código IPSA:</label>
                  <div className="form-control">
                    {this.props.regente.codigo_ipsa}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4">
                <div className="form-group">
                  <label>Nombre:</label>
                  <div className="form-control">
                    {this.props.regente.nombres}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label>Apellido paterno:</label>
                  <div className="form-control">
                    {this.props.regente.apellido_paterno}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label>Apellido materno:</label>
                  <div className="form-control">
                    {this.props.regente.apellido_materno}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4">
                <div className="form-group">
                  <label>Correo electrónico:</label>
                  <div className="form-control">
                    {this.props.regente.correo_electronico}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label>Télefono convencional:</label>
                  <div className="form-control">
                    {this.props.regente.telefono_convencional}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label>Celular:</label>
                  <div className="form-control">
                    {this.props.regente.telefono_celular}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Dirección:</label>
                  <div className="form-control">
                    {this.props.regente.direccion}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Departamento:</label>
                  <div className="form-control">
                    {this.props.regente.departamento}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label>Municipio:</label>
                  <div className="form-control">
                    {this.props.regente.municipio}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Profesión:</label>
                  <div className="form-control" style={{overflow: "auto"}}>
                    {this.props.regente.profesiones}
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </>
    );
  }
}

export default InfoForm;
